import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { AudioWaveform, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errorText } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={loc.state?.from || "/episodes"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(email.trim(), password);
      nav(loc.state?.from || "/episodes", { replace: true });
    } catch (err) {
      setError(errorText(err, "Login failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center px-4">
      <form onSubmit={submit} data-testid="login-form" className="panel w-full max-w-sm p-6 space-y-5 fade-up">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-sm bg-[#E11D48] grid place-items-center"><AudioWaveform size={18} className="text-white" /></div>
          <div>
            <div className="font-display font-bold text-lg leading-tight">Gulmohar</div>
            <div className="micro">M&E Separation Engine · Team sign-in</div>
          </div>
        </div>
        <label className="block">
          <span className="micro">Email</span>
          <input data-testid="login-email-input" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full bg-[#0B0E14] border border-[#253044] rounded-sm px-3 py-2 text-sm font-mono focus:outline-none focus:border-cyan-500" />
        </label>
        <label className="block">
          <span className="micro">Password</span>
          <input data-testid="login-password-input" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full bg-[#0B0E14] border border-[#253044] rounded-sm px-3 py-2 text-sm font-mono focus:outline-none focus:border-cyan-500" />
        </label>
        {error && <div data-testid="login-error" className="text-xs text-rose-300 bg-rose-500/10 border border-rose-800 rounded-sm px-3 py-2">{error}</div>}
        <button data-testid="login-submit-button" disabled={busy} type="submit"
          className="w-full h-10 rounded-sm bg-[#E11D48] hover:bg-[#be123c] text-white text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-50">
          <LogIn size={15} /> {busy ? "Signing in…" : "Sign in"}
        </button>
        <div className="text-[11px] text-slate-500">No self-signup. Ask your administrator for an account (Team page).</div>
      </form>
    </div>
  );
}
